import { render, staticRenderFns } from "./WorkOrdersForm.vue?vue&type=template&id=422ab87c"
import script from "./WorkOrdersForm.vue?vue&type=script&lang=js"
export * from "./WorkOrdersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports